<div class="modal fade modal-full-width modal-full-height"
    [class.campanha-status-nao-confirmada]="config?.isNaoConfirmada"
    [class.campanha-status-em-analise]="config?.isEmAnalise || config?.isEmAnaliseSearch"
    [class.campanha-status-em-andamento]="config?.isEmAndamento && !config?.isEmAnaliseSearch"
    [class.campanha-status-em-revisao]="config?.isEmRevisao"
    [class.campanha-status-encerrada]="config?.isEncerrada  && !config?.isEmAnaliseSearch"
    [class.campanha-status-reprovada]="config?.isReprovada">
    
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">

            <div class="modal-loading" *ngIf="isLoading">
                <sgt-loading-info
                    title="Carregando Campanha"
                    text="Aguarde um momento enquanto estamos carregando a campanha">
                </sgt-loading-info>
            </div>

            <ng-template [ngIf]="!isLoading && campanha">
                <div class="modal-header">
                    <div class="modal-header-titles">
                        <h6 class="modal-title" *ngIf="!config?.isSemCampanha">
                            Campanha #{{campanha.numero}}
                        </h6>
                        <h4 class="modal-title">
                            {{campanha.nome}}
                        </h4>                        
                    </div>
                    <div class="modal-header-status">
                        <h6 class="modal-title">
                            {{statusCampanha | campanhaStatus}}
                        </h6>
                    </div>
                </div>            
                <div class="modal-body"> 
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active" data-target="#tabPedidosNaoLiberados" data-toggle="tab" (click)="resize()" *ngIf="config?.isLiberandoPedidos">Pedidos Não Liberados</a>
                        </li>                    
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="!config?.isLiberandoPedidos" data-target="#tabROI" data-toggle="tab">ROI</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-target="#tabRecursos" data-toggle="tab" (click)="resize()">Recursos</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-target="#tabPromocao" data-toggle="tab" *ngIf="!config?.isSemCampanha">Promoção</a>
                        </li>  
                        <li class="nav-item">
                            <a class="nav-link" data-target="#tabRepresentantes" data-toggle="tab" *ngIf="config?.isShowTabRepresentante">Representantes</a>
                        </li>                                       
                        <li class="nav-item">
                            <a class="nav-link" data-target="#tabResultado" data-toggle="tab" (click)="onTabResultadoClick()">Resultado</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-target="#tabDadosCampanha" data-toggle="tab" *ngIf="!config?.isSemCampanha" (click)="resize()">Dados da Campanha</a>
                        </li>                        
                    </ul>
                    <div class="tab-content">
                        <!-- Pedidos Não Liberdados -->
                        <div class="tab-pane tab-pane-pedidos-nao-liberados active" id="tabPedidosNaoLiberados" *ngIf="config?.isLiberandoPedidos">
                            <sgt-campanha-pedido-liberar
                                #pedidosLiberar
                                [idCampanha]="campanha.id"
                                [filter]="filter"
                                (afterLiberarPedido)="afterLiberarPedidos.emit()">
                            </sgt-campanha-pedido-liberar>
                        </div>
                        <!-- ROI -->
                        <div class="tab-pane tab-pane-roi" [class.active]="!config?.isLiberandoPedidos" id="tabROI">
                            <sgt-campanha-roi-widgets
                                [isLoading]="isLoading"
                                [valorTotalRecursos]="campanha.resultado?.roi?.valorTotalDespesas"
                                [valorTotalResultado]="campanha.resultado?.roi?.valorTotalVendas"
                                [roi]="campanha.resultado?.roi?.retornoEfetivo">
                            </sgt-campanha-roi-widgets>
                        </div>
    
                        <!-- Recursos -->
                        <div class="tab-pane tab-pane-recursos" id="tabRecursos">
                            <sgt-campanha-recurso-view
                                #recursosView
                                [idCampanha]="campanha.id"
                                [isStatusEmAnalise]="config?.isEmAnaliseSearch"
                                [idArea]="campanha.idArea"
                                [filter]="filter"
                                [recursos]="campanha.recursos"
                                [quantidadePedidosBonificacoes]="campanha.resultado?.quantidadePedidosBonificacoes"
                                [quantidadePedidosBonificacoesNaoLiberados]="campanha.resultado?.quantidadePedidosBonificacoesNaoLiberados"
                                [quantidadeTotalPedidosBonificacoes]="campanha.resultado?.quantidadeTotalPedidosBonificacoes"
                                [valorTotalPedidosBonificacoes]="campanha.resultado?.valorTotalPedidosBonificacoes"
                                [valorTotalDespesas]="campanha.resultado?.valorTotalDespesas"
                                [quantidadePedidosVendasNaoLiberados]="campanha.resultado?.quantidadePedidosVendasNaoLiberados">
                            </sgt-campanha-recurso-view>  
                        </div>
                        
                        <!-- Promoção -->
                        <div class="tab-pane tab-pane-dados-campanha" id="tabPromocao" *ngIf="!config?.isSemCampanha">
                            <sgt-campanha-promocao-form
                                [tipoPromocao]="campanha.tipoPromocao"
                                [clientes]="campanha.clientes"
                                [canEdit]="false">
                            </sgt-campanha-promocao-form>
                        </div>
    
                        <!-- Representantes -->
                        <div class="tab-pane tab-pane-representantes" id="tabRepresentantes" *ngIf="config?.isShowTabRepresentante">
                            <sgt-campanha-representante
                                #representantesForm
                                [entities]="campanha.representantes"
                                [canEdit]="false">
                            </sgt-campanha-representante>                
                        </div>                    
                        
                        <!-- Resultado -->
                        <div class="tab-pane tab-pane-resultado" id="tabResultado">
                            <sgt-campanha-resultado-view
                                #resultadoView
                                [idCampanha]="campanha.id"
                                [isStatusEmAnalise]="config?.isEmAnaliseSearch"
                                [filter]="filter"
                                [resultado]="campanha.resultado"
                                [isShowAquisicoes]="!config.isSemCampanha">
                            </sgt-campanha-resultado-view>
                        </div>  
                        
                        <!-- Dados da Campanha -->
                        <div class="tab-pane tab-pane-dados-campanha" id="tabDadosCampanha" *ngIf="!config?.isSemCampanha">
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label">Área</label>
                                    <input type="text" class="form-control" [value]="campanha.area?.nome" disabled="disabled" readonly="readonly">
                                </div>                                              
                            </div>    
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label">Pacote</label>
                                    <input type="text" class="form-control" [value]="campanha.pacoteCampanha?.nome" disabled="disabled" readonly="readonly">
                                </div>  
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label">Descrição</label>
                                    <textarea class="form-control" disabled="disabled" readonly="readonly" rows="5">{{campanha.descricao}}</textarea>
                                </div>
                            </div>

                            <!-- Arquivos -->
                            <div class="row">
                                <div class="form-group col-12">
                                    <sgt-arquivo-card-view
                                        #arquivosCardView
                                        [referencia]="config?.referenciaArquivos"
                                        [idReferencia]="campanha.id"
                                        headerText="Arquivos desta campanha"
                                        idTable="campanhaArquivosTable"
                                        [canEdit]="false">
                                    </sgt-arquivo-card-view>                                    
                                </div>
                            </div>
                            
                            <!-- Vigência -->
                            <div class="row">
                                <div class="form-group col-12">
                                    <sgt-campanha-vigencia-form
                                        #vigenciaForm
                                        subTitle="Selecione se esta é uma campanha recorrente"
                                        inputLabel="Esta campanha é recorrente?"
                                        inputHelpText="Uma campanha recorrente é aquela que não possui uma data de término definida e que ocorre repetidamente sem prazo de vigência determinado"                                    
                                        [sobDemanda]="campanha.pacoteCampanha?.sobDemanda"
                                        [entity]="campanha"
                                        [canEdit]="false">
                                    </sgt-campanha-vigencia-form>
                                </div>
                            </div>   
                            
                            <div class="row">
                                <div class="form-group col-12 col-md-4 col-xl-3">
                                    <label class="col-form-label">Orçamento Disponível</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">R$</span>
                                        </div>
                                        <input type="text" class="form-control text-right" [value]="campanha.orcamentoDisponivel | decimalFormat: 1:2:2" disabled="disabled" readonly="readonly">
                                    </div>
                                    <p class="form-text">Orçamento disponível para esta campanha</p>
                                </div>                               
                            </div> 
    
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label">Cliente</label>
                                    <sgt-typeahead-cliente [(ngModel)]="campanha.cliente" name="campanhaCliente" id="campanhaCliente"
                                        #campanhaCliente="ngModel" [ngControl]="campanhaCliente"
                                        [disabled]="true" [readonly]="true">
                                    </sgt-typeahead-cliente>
                                    <p class="form-text">Cliente diretamente vinculado à esta campanha</p>
                                </div>
                            </div> 

                            <!-- Cupons -->
                            <div class="row">
                                <div class="form-group col-12">
                                    <sgt-campanha-cupons-form
                                        [(cupons)]="campanha.cupons"
                                        [canEdit]="false">
                                    </sgt-campanha-cupons-form>
                                </div>
                            </div>                            
    
                            <!-- Tabelas de Preços -->
                            <div class="row">
                                <div class="form-group col-12">
                                    <sgt-campanha-tabela-preco-form
                                        [entities]="campanha.tabelasPrecos"
                                        [canEdit]="false">
                                    </sgt-campanha-tabela-preco-form>
                                </div>
                            </div>                                                     
    
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label">Cidade</label>
                                    <sgt-typeahead-cidade [(ngModel)]="campanha.cidade" name="campanhaCidade" id="campanhaCidade"
                                        #campanhaCidade="ngModel" [ngControl]="campanhaCidade" [disabled]="true" [readonly]="true">
                                    </sgt-typeahead-cidade>
                                    <p class="form-text">Cidade onde esta campanha está sendo realizada (Para campanhas presenciais)</p>
                                </div>
                            </div>  
                            
                            <div class="row">
                                <div class="form-group col-12">
                                    <label class="col-form-label">Link Landing Page</label>
                                    <sgt-url [(ngModel)]="campanha.landingPageURL" name="landingPageURL" id="landingPageURL"
                                        #landingPageURL="ngModel" [ngControl]="landingPageURL" [disabled]="true" [readonly]="true">
                                    </sgt-url>
                                    <p class="form-text">Link da landing page onde esta campanha está sendo realizada (Para campanhas on-line)</p>
                                </div>
                            </div>                         
                        </div>                          
                    </div>                
                </div>
            </ng-template>

            <div class="modal-footer" *ngIf="!isLoading">      
                <button type="button" class="btn btn-light" (click)="close()">
                    <i class="fas fa-times"></i> Fechar
                </button> 

                <!-- Liberando pedidos -->
                <ng-template [ngIf]="config?.isLiberandoPedidos">
                    <button type="button" class="btn btn-warning" (click)="liberarPedidos()" id="btnLiberarPedidos">
                        <i class="far fa-thumbs-up"></i> Liberar Pedido(s)
                    </button> 
                </ng-template>
            </div>            
        </div>
    </div>
</div>